/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
import "vant/es/toast/style";
import _Toast from "vant/es/toast";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/*
 * @Description:
 * @Date: 2020-07-27 11:25:02
 */


import axios from 'axios';
import qs from 'qs';
import router from '@/router/index'; // import { getStorage, setBeforeRegisterUrl } from '@/utils/storage';

var service = axios.create({
  baseURL: process.env.BASE_API,
  // api的base_url
  timeout: 60000,
  // request timeout
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  } //multipart/form-data application/json;charset=UTF-8

});
service.interceptors.request.use(function (config) {
  // const isAdmin = router.currentRoute.query.platform === 'admin';
  if (router.currentRoute.query.platform === 'admin') {
    config.headers['flag'] = 'admin';
  } // 修改为YAPI路径,根据config.yapi来补齐yapi地址


  if (config.yapi && process.env.NODE_ENV !== 'production') {
    config.url = "http://yapi.jimijiayuan.cn/mock/".concat(config.yapi).concat(config.url);
  }

  if (config.method == 'post') {
    // 暂时使用
    var params = config.data || {}; // end

    if (!/fileUpload/.test(config.url) && !config.notUseQs) {
      config.data = qs.stringify(params);
    }
  }

  return config;
}, function (error) {
  // Do something with request error
  console.log(error); // for debug

  Promise.reject(error);
}); // respone interceptor

service.interceptors.response.use(function (response) {
  // return response
  var res = response.data;

  if (res.status == 1) {
    return _objectSpread(_objectSpread({}, response), {}, {
      pdata: res.data
    });
  } else {
    // 管理预览不处理异常
    var isAdmin = router.currentRoute.query.platform === 'admin';

    if (isAdmin) {
      return Promise.reject();
    }

    if (res.status == -999) {
      // 缓存URL
      // setBeforeRegisterUrl();
      //去注册
      router.replace({
        name: 'register'
      }).catch(function (err) {
        return err;
      });
    } else if (res.status == -998) {
      //未完善
      router.replace({
        name: 'perfect'
      }).catch(function (err) {
        return err;
      });
    } else if (res.status == -997) {
      //需要口令
      router.replace({
        name: 'word'
      }).catch(function (err) {
        return err;
      });
    } else if ([-995, -994, -993, -992].includes(+res.status)) {
      // 停用 删除 下架 内容下架
      router.replace({
        name: 'stop',
        query: {
          type: res.status
        }
      });
    }

    _Toast.fail(res.message);

    return Promise.reject(res);
  }
}, function (error) {
  console.log(error, '---error');
  return Promise.reject(error);
});
export default service;